import { sharedEnv } from '@football-kids/shared/utils/env';
import merge from 'lodash.merge';


export type ChatwootSettings = {
    baseUrl: string;
    apiAccessToken: string;
    webhookSecret: string;
    openaiModel: string;
    openaiApiKey: string;
};

const DEFAULT_APP_SETTINGS = {
    project: 'server-fkids',
    height: {
        min: 92,
        max: 146
    },
    age: {
        min: 1,
        max: 8
    },
    emails: {
        'appColor': '#487048',
        'appContrastColor': '#fff',
        'companyTitle': 'Football Kids',
        'companyDomain': 'football-kids.com',

        'defaultSenderAddress': 'info@football-kids.com',
        'defaultSenderName': 'Info - Football Kids'
    },
    agreements: { 'companyTitle': 'Football Kids', 'termsWebsite': 'football-kids.com' },
    payments: { 'descriptionPrefix': 'FootballKids' },
    registrationFee: 17500,
    firstPaymentMonth: 8, // 0 indexed!
    enabledModules: {
        'achievements': false,
        'inventory': false,
        'aiRouter': false,
        'chatwoot': false
    },
    chatwoot: {
        baseUrl: '',
        apiAccessToken: '',
        webhookSecret: '',
        openaiModel: 'gpt-4o',
        openaiApiKey: '',
    } as ChatwootSettings,
    medusa: {
        apiUrl: '',
        apiPublishableKey: '',
        adminApiKey: '',
    }
};

export type AppSettings = typeof DEFAULT_APP_SETTINGS;

export const APP_SETTINGS: AppSettings = merge({}, DEFAULT_APP_SETTINGS, JSON.parse(sharedEnv('APP_SETTINGS') || '{}'));
